"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _styles = require("@mui/material/styles");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param testid
 * @param title
 * @param subtitle
 * @param paragraph
 * @param classes
 * @param btnsAbove
 * @param formatted
 * @param checkbox
 * @param checked
 * @param btnName
 * @param btn
 * @param btnOnClick
 * @param btnCustomStyle
 * @param btnName2
 * @param btn2
 * @param btnOnClick2
 * @param btnCustomStyle2
 * @param isError
 * @param onChangeCheckbox
 * @returns {JSX.Element}
 * @constructor
 */
var MessageCard = function MessageCard(_ref) {
  var testid = _ref.testid,
    title = _ref.title,
    subtitle = _ref.subtitle,
    paragraph = _ref.paragraph,
    classes = _ref.classes,
    btnsAbove = _ref.btnsAbove,
    formatted = _ref.formatted,
    checkbox = _ref.checkbox,
    checked = _ref.checked,
    btnName = _ref.btnName,
    btn = _ref.btn,
    btnOnClick = _ref.btnOnClick,
    btnCustomStyle = _ref.btnCustomStyle,
    btnName2 = _ref.btnName2,
    btn2 = _ref.btn2,
    btnOnClick2 = _ref.btnOnClick2,
    btnCustomStyle2 = _ref.btnCustomStyle2,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    onChangeCheckbox = _ref.onChangeCheckbox;
  var theme = (0, _styles.useTheme)();

  /**
  * @param theme
  */
  var styles = {
    flexBlock: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    subtitleBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline'
    },
    checkBlock: {
      display: 'block'
    },
    cardStyle: {
      display: 'flex',
      flex: 1,
      backgroundColor: theme.palette.primary.light,
      boxShadow: 'none',
      padding: 20,
      minHeight: 35,
      flexDirection: 'row',
      borderLeft: 'solid',
      borderLeftWidth: 5,
      borderColor: theme.palette.primary.main
    },
    small: {
      maxWidth: 1000
    },
    btnStyle: {
      width: 'fit-content'
    },
    icon: {
      color: isError ? '#DA3328' : theme.palette.primary.main
      // marginRight: 1,
      // marginLeft: 1
    }
  };

  /**
   * 
   * @returns 
   */
  var setErrorStyling = function setErrorStyling(element) {
    if (isError && element === "div") {
      return {
        backgroundColor: '#FCE8E6',
        borderColor: '#DA3328'
      };
    }
    if (isError && element === "button") {
      return {
        borderColor: '#DA3328'
      };
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: "24px 0",
      flex: 1
    }
  }, btn && btnsAbove && /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.flexBlock), {}, {
      marginBottom: 10
    })
  }, btn2 && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    testid: testid,
    customStyle: _objectSpread(_objectSpread(_objectSpread({}, styles.btnStyle), btnCustomStyle2), setErrorStyling("button")),
    onClick: btnOnClick2,
    transparent: true
  }, btnName2), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    testid: testid,
    color: "primary",
    customStyle: _objectSpread(_objectSpread(_objectSpread({}, styles.btnStyle), btnCustomStyle), setErrorStyling("button")),
    onClick: btnOnClick
  }, btnName)), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.cardStyle), setErrorStyling("div"))
  }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
    sx: styles.icon,
    size: 20
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: 20,
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    testid: testid,
    align: "left",
    mediumLarge: true,
    bold: true,
    display: "block",
    margin: "0 0 5px 0"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.subtitleBlock
  }, checkbox && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.checkBlock
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: checked,
    onChange: onChangeCheckbox,
    color: "primary"
  })), subtitle && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "left",
    medium: true,
    display: "block",
    formatted: formatted
  }, subtitle)), paragraph && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "left",
    small: true,
    margin: "20px 0px 20px 0px",
    display: "block"
  }, paragraph))), btn && !btnsAbove && /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.flexBlock), {}, {
      marginTop: 10
    })
  }, btn2 && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    testid: testid,
    customStyle: _objectSpread(_objectSpread(_objectSpread({}, styles.btnStyle), btnCustomStyle2), setErrorStyling("button")),
    onClick: btnOnClick2,
    transparent: true
  }, btnName2), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    testid: testid,
    color: "primary",
    onClick: btnOnClick,
    customStyle: _objectSpread(_objectSpread(_objectSpread({}, styles.btnStyle), btnCustomStyle), setErrorStyling("button"))
  }, btnName)));
};
var _default = exports["default"] = MessageCard;